import { Controller } from 'stimulus';

export default class extends Controller {
  static targets = [ 'container', 'backdrop', 'closeBtn' ]

  connect() {
    this.toggleClass = '-left-full'
    this.element[this.identifier] = this
  }

  open(e) {
    e.preventDefault()

    this.containerTarget.classList.remove(this.toggleClass)
    this.backdropTarget.classList.remove('hidden')
    setTimeout(() => this.closeBtnTarget.classList.replace('absolute', 'fixed'), 200)
    this.positionCloseBtn()
    this.scrollLock()
  }

  close(e) {
    e.preventDefault()

    this.containerTarget.classList.add(this.toggleClass)
    this.backdropTarget.classList.add('hidden')
    this.closeBtnTarget.classList.replace('fixed', 'absolute')
    this.scrollUnlock()
  }

  closeWithEsc(e) {
    if (e.keyCode === 27 && !this.containerTarget.classList.contains(this.toggleClass)) {
      this.close(e);
    }
  }

  scrollLock() {
    const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
    document.body.style.paddingRight = `${scrollbarWidth}px`;

    this.scrollPosition = window.pageYOffset || document.body.scrollTop;

    document.body.classList.add('fixed', 'inset-x-0', 'overflow-hidden');

    document.body.style.top = `-${this.scrollPosition}px`;
  }

  scrollUnlock() {
    document.body.style.paddingRight = null;

    document.body.classList.remove('fixed', 'inset-x-0', 'overflow-hidden');

    document.documentElement.scrollTop = this.scrollPosition;

    document.body.style.top = null;
  }

  positionCloseBtn() {
    if (window.innerWidth < 1024) {
      this.closeBtnTarget.style.top = `${this.containerTarget.getBoundingClientRect().top + 14}px`
      this.closeBtnTarget.style.left = `${this.containerTarget.getBoundingClientRect().width - 40}px`
    } else {
      this.closeBtnTarget.style.top = `${this.containerTarget.getBoundingClientRect().top + 20}px`
      this.closeBtnTarget.style.left = `${this.containerTarget.getBoundingClientRect().width - 52}px`
    }
  }
}
